"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var SubNav = /*#__PURE__*/function (_React$Component) {
  _inherits(SubNav, _React$Component);

  function SubNav(props) {
    var _this;

    _classCallCheck(this, SubNav);

    _this = _possibleConstructorReturn(this, (SubNav.__proto__ || Object.getPrototypeOf(SubNav)).call(this, props));
    _this.state = {
      isOpen: false,
      currentItem: {}
    };
    _this.goBack = _this.goBack.bind(_assertThisInitialized(_this));
    _this.toggleNav = _this.toggleNav.bind(_assertThisInitialized(_this));
    _this.itemClick = _this.itemClick.bind(_assertThisInitialized(_this));
    _this.bindScrollEvent = _this.bindScrollEvent.bind(_assertThisInitialized(_this));

    if (props.scrollableContainer) {
      _this.scrollableContainer = document.querySelector(_this.props.scrollableContainer);
    }

    _this.bindScrollEvent();

    return _this;
  }

  _createClass(SubNav, [{
    key: "bindScrollEvent",
    value: function bindScrollEvent() {
      var _this2 = this;

      var sections = [],
          scrollPositionOffsetFraction = .5,
          activateItem = function activateItem(anchorId) {
        for (var i = _this2.props.items.length; i--;) {
          if (_this2.props.items[i].anchor === anchorId) {
            _this2.setState({
              currentItem: _this2.props.items[i]
            });

            break;
          }
        }
      },
          checkPosition = function checkPosition() {
        var tmp = window.innerHeight * scrollPositionOffsetFraction;

        _this2.props.items.forEach(function (item) {
          sections.push(document.getElementById(item.anchor));
        });

        for (var i = sections.length; i--;) {
          if (sections[i] === null) continue;

          if (sections[i].getBoundingClientRect().top < tmp) {
            activateItem(sections[i].id);
            break;
          }
        }
      };

      if (this.scrollableContainer) {
        this.scrollableContainer.addEventListener('scroll', function () {
          return requestAnimationFrame(checkPosition);
        });
      }

      window.addEventListener('scroll', function () {
        return requestAnimationFrame(checkPosition);
      });
    }
  }, {
    key: "goBack",
    value: function goBack(e) {
      e.preventDefault();
      window.history.back();
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: "itemClick",
    value: function itemClick(e) {
      e.preventDefault(); // get scrollTop position

      var section = document.getElementById(e.target.getAttribute('data-anchor'));
      window.scrollTo(0, section.offsetTop - this.props.scrollTopOffset);

      if (this.scrollableContainer && this.scrollableContainer.scrollTo) {
        this.scrollableContainer.scrollTo(0, section.offsetTop - this.props.scrollTopOffset);
      }

      this.setState({
        isOpen: false,
        currentItem: {
          label: e.target.getAttribute('data-label'),
          anchor: e.target.getAttribute('data-anchor')
        }
      });
    }
  }, {
    key: "toggleNav",
    value: function toggleNav(e) {
      e.preventDefault();
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var items = this.props.items.map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "sub-nav__item",
          key: index
        }, /*#__PURE__*/_react.default.createElement("a", {
          className: "sub-nav__link".concat(_this3.state.currentItem.anchor === item.anchor ? ' is-active' : ''),
          onClick: _this3.itemClick,
          href: '#' + item.anchor,
          "data-label": item.label,
          "data-anchor": item.anchor
        }, item.label));
      });
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "",
        onClick: this.toggleNav,
        className: 'sub-nav-trigger ' + (this.state.isOpen ? 'is-open' : '')
      }, this.state.currentItem.label || '', /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-down"
      })), /*#__PURE__*/_react.default.createElement("div", {
        id: "sub-nav-wrapper",
        className: 'sub-nav-wrapper ' + (this.state.isOpen ? 'is-open' : '')
      }, !this.props.disableBackLink && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
        className: "back-link",
        href: "",
        onClick: this.goBack
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-down"
      }), /*#__PURE__*/_react.default.createElement("span", null, this.props.t('zurück')))), /*#__PURE__*/_react.default.createElement("ul", {
        className: "sub-nav"
      }, items)));
    }
  }]);

  return SubNav;
}(_react.default.Component);

SubNav.defaultProps = {
  scrollableContainer: null,
  scrollTopOffset: 0,
  disableBackLink: false
};
SubNav.propTypes = {
  t: _propTypes.default.func.isRequired,
  scrollableContainer: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    anchor: _propTypes.default.string
  })),
  scrollTopOffset: _propTypes.default.number,
  disableBackLink: _propTypes.default.bool
};

var _default = (0, _translate.default)(SubNav);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/sub-nav/index.js
// module id = 744
// module chunks = 0